import { useState } from "react";
import { ListItem, ListItemText, ListItemIcon } from "@mui/material";
import DeleteWalletConfirmationModal from "./Modals/DeleteWalletConfirmationModal";
import { DeleteOutlineOutlined, EditOutlined } from "@mui/icons-material";
import EditWalletModal from "./Modals/EditWalletModal";

export default function WalletsLine({ wallet, type }) {
	const [deleteWallet, setDeleteWallet] = useState();
	const [isEditWalletModalOn, setIsEditWalletModalOn] = useState(false);

	return (
		<>
			<ListItem key={wallet._id} sx={{ pl: 3, pt: 0, pb: 0 }}>
				<ListItemText primary={wallet.name} />
				<ListItemText
					sx={{ textAlign: "right", ml: 1 }}
					primary={`${wallet.balance.toFixed(2).toLocaleString()} ${wallet.currency}`}
				/>
				<ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
					<EditOutlined
						className="hover"
						onClick={() => setIsEditWalletModalOn(true)}
					/>
				</ListItemIcon>
				<ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
					<DeleteOutlineOutlined
						className="hover"
						onClick={() => setDeleteWallet(wallet)}
					/>
				</ListItemIcon>
			</ListItem>
			{deleteWallet && (
				<DeleteWalletConfirmationModal
					walletId={deleteWallet._id}
					walletName={deleteWallet.name}
					onClose={() => setDeleteWallet(null)}
					type={type}
				/>
			)}
			{isEditWalletModalOn && (
				<EditWalletModal
					isOpen={isEditWalletModalOn}
					onClose={() => setIsEditWalletModalOn(false)}
					type={type}
					wallet={wallet}
				/>
			)}
		</>
	);
}
